import { type ZodTypeAny, z } from "zod";

export { z } from "zod";

type SchemaFor<T extends Record<string, any>> = {
	[K in keyof T]: ZodTypeAny;
};

export function createSchema<T extends Record<string, any>>(shape: SchemaFor<T>) {
	return z.object(shape);
}
